import React, {Component} from 'react'
import ModalEditStatus from "./ModalEditStatus"


class ProductionStatus extends Component {
    state = {
        isOpen: false,
    }

    _handleClose = () => {
        this.setState({
            isOpen: false,
        }, () => {
            return this.props.reloadItems()
        })
    }

    _handleOpen = e => {
        e.preventDefault()

        this.setState({
            isOpen: true
        })
    }

    render() {
        const {item} = this.props
        const {production_status} = item
        const {isOpen} = this.state

        return (
            <div className="ProductionStatus ml-3">
                <label>Status:</label> {production_status}
                <i aria-label="Change status" onClick={this._handleOpen} className="icon-pencil ml-1"/>
                <ModalEditStatus onClose={this._handleClose} isOpen={isOpen} item={item}
                                 status={item.production_status}/>
            </div>
        )
    }
}

export default ProductionStatus
